import React from 'react'

const Button = ({ className, label, onClick, type , href='#' }) => {
    return (
        <a href={href} className={`${className} ${type}`}>{label}</a>
    )
}

export default Button